import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";

class ProvidersDossiersPanel extends Component {
    constructor(props) {
        super();
        this.state = {
            all: [],
            statuses: [],
            status: null,
            statusDossiers: null,
            search:'',
            page: 1,
            total: 0,
            index: 0,
            maxRecords: props.top,
            orderBy : {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
            orderOptions : [
                {value: 'date', dir: 'desc', text: 'Por fecha - Mas Recientes' },
                {value: 'date', dir: 'asc', text: 'Por Fecha - Mas Antiguos' },
                {value: 'fiscal_name', dir: 'asc', text: 'Por Nombre A - Z' },
                {value: 'fiscal_name', dir: 'desc', text: 'Por Nombre Z - A' },
            ],
        };
        this.loadStatus = this.loadStatus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    changeOrderOption(option){
        this.setState({orderBy: option}, function(){
            this.getAll();
        });
    }

    componentDidMount() {

        this.getStatuses()
        this.getAll()
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value, page: 1}, function () {
            this.getAll();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getAll();
        });
    }

    async getStatuses(){
        const res = await axios.get('/api/dossiers/status')
        const data = res.data;
        this.setState({statuses: data});

        var statusDossiers = [];
        this.state.statuses.map((s) => {
            statusDossiers = [...statusDossiers, []];
        });
        this.setState({statusDossiers: statusDossiers})
    }

    showAll(){
        this.setState({all: [], page: 1, status: null, index: null}, () => {
            this.getAll();
        });
    }

    loadStatus(index){
        const status = this.state.statuses[index];
        this.setState({all: [], page: 1, status: status.id}, () => {
            this.getAll();
        });
    }

    async getAll(){
       
        var url = '/api/clients/dossiers/providers';
        const query = new URLSearchParams();

        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.status!=null){
            query.append('status', this.state.status);
        }

        if(this.state.orderBy.value != ''){
            query.append('orderBy', this.state.orderBy.value);
            query.append('orderByDir', this.state.orderBy.dir);
        }
        query.append('type', 1);
        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;
        
        const res = await axios.get(url);
        const data = res.data.data;
       
        this.setState({all: data, total: res.data.total});
        
    }

    getDossierTypeColor(type_id){
        if(type_id == 1) return 'danger'; // Nacional
        if(type_id == 2) return 'success'; // Internacional
        if(type_id == 3) return 'info'; // Especiales
        if(type_id == 4) return 'warning'; // Otros
    }

    render() {
        return (
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75"> sss{this.props.title} </span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">{this.state.total} expedientes</span>
                    </h3>
                    <div className="card-toolbar">
                        <div>
                            {this.props.dashboard=="false" &&
                                <div className="input-icon mb-4">
                                    <input
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar expedientes" />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            }
                            <ul className="nav nav-pills nav-pills-sm nav-dark">
                                <li className="nav-item ml-0">
                                    <a href={"#ts_all"} className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==null ? "active" : ""}`} onClick={() => this.showAll()} >Todos</a>
                                </li>
                                {this.state.statuses.map((status, i) => {
                                    return <li key={i} className="nav-item ml-0" onClick={() => this.loadStatus(i)} >
                                        <a href={"#ts_" + i } className={`nav-link py-2 px-4 font-weight-bolder font-size-sm ${this.state.status==status.id ? "active" : ""}`}>{ status.name }</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body pt-1">
                    {this.props.dashboard=="false" &&
                        <div className="dropdown text-right">
                            <button className="btn btn-secondary btn-sm dropdown-toggle text-primary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ordenar {this.state.orderBy.text}
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                {this.state.orderOptions.map((option, i) => {
                                    return <a onClick={() => this.changeOrderOption(option)} key={i} className="dropdown-item" href="#">{ option.text }</a>
                                })}
                            </div>
                        </div>
                    }
                    <div className="table-responsive">
                        <table className="table table-borderless table-vertical-center">
                            <tbody>
                                {this.state.all.map((d, index) => {
                                    return <tr key={index}>
                                        <td className="pl-0 py-5">
                                            <div className="symbol symbol-40">
                                                <div className={"symbol-label text-white font-weight-bolder bg-"+this.getDossierTypeColor(d.dossier?.dossier_type_id)}>
                                                    { d.dossier?.target.name[0] }
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                    { d.provider != null ? d.provider?.fiscal_name : d.name }
                                                </div>
                                                <span className="text-dark-50 font-weight-bold">{d.dossier?.title}  </span>
                                                <br/>
                                                <span className="text-muted font-weight-bold font-size-sm">
                                                    <span className={'badge badge-'+d.dossier?.status.toString().toLowerCase()}>{d.dossier?.status}</span>
                                                </span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.total}</div>
                                                <span className="text-muted font-weight-bold">Total de Documentos</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.pending}</div>
                                                <span className="text-muted font-weight-bold">Por cargar</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.loaded}</div>
                                                <span className="text-muted font-weight-bold">Por revisar</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.approved}</div>
                                                <span className="text-muted font-weight-bold">Aprobadas</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.rejected}</div>
                                                <span className="text-muted font-weight-bold">Rechazados</span>
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">{d.dossier?.expired}</div>
                                                <span className="text-muted font-weight-bold">Historial</span>
                                            </a>
                                        </td>
                                        <td className="text-right">
                                            <a href={"/clients/dossiers/" + d.id}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                </button>
                                            </a>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                    { this.props.dashboard == "true" ?
                        <div className="text-right">
                            <a href="/clients/dossiers">Ver todos</a>
                        </div>
                    :
                        <div></div>
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }

            </div>
            </>
        );
    }
}

export default ProvidersDossiersPanel;

if (document.getElementById('ProvidersDossiersPanel')) {
    ReactDOM.render(<ProvidersDossiersPanel />, document.getElementById('ProvidersDossiersPanel'));
}
